// extracted by mini-css-extract-plugin
export default {"prefix":"Yc3QwCX2lmiyc0PBITix"};